import React from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  text?: string;
};

const LegacyWarningLabel = ({ className, size = 'medium', text }: Props) => (
  <div className={classNames('legacy-warning-label', className, size)}>
    <i className="icon-warning" />
    {text && <span>{text}</span>}
  </div>
);

export default LegacyWarningLabel;
